import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/program-avatar.jpg'
import _imports_1 from '@/assets/images/program-poster.jpg'
import _imports_2 from '@/assets/images/program-opening.jpg'
import _imports_3 from '@/assets/images/program-tour.jpg'
import _imports_4 from '@/assets/images/program-talk_1.jpg'
import _imports_5 from '@/assets/images/program-kemoclub_1.jpg'
import _imports_6 from '@/assets/images/program-talk_2.jpg'
import _imports_7 from '@/assets/images/program-modify.jpg'
import _imports_8 from '@/assets/images/program-kemoclub_2.jpg'
import _imports_9 from '@/assets/images/program-talk_3.jpg'
import _imports_10 from '@/assets/images/program-photo.jpg'
import _imports_11 from '@/assets/images/program-ending.jpg'
import _imports_12 from '@/assets/images/program-ddp.jpg'
import _imports_13 from '@/assets/images/banner_avatarposter.jpg'


const _withScopeId = n => (_pushScopeId("data-v-a3b848bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "program-wrap" }
const _hoisted_2 = {
  class: "program-box",
  id: "avatar_dressing_room"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "program-inner" }
const _hoisted_5 = { class: "program-time" }
const _hoisted_6 = { class: "program-place" }
const _hoisted_7 = {
  class: "program-box",
  id: "poster_exhibition"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "program-inner" }
const _hoisted_10 = { class: "program-time" }
const _hoisted_11 = { class: "program-place" }
const _hoisted_12 = {
  class: "program-box",
  id: "opening"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "program-inner" }
const _hoisted_15 = { class: "program-time day-1" }
const _hoisted_16 = { class: "program-place" }
const _hoisted_17 = {
  class: "program-box",
  id: "beginner_tour_1"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_19 = { class: "program-inner" }
const _hoisted_20 = { class: "program-time day-2" }
const _hoisted_21 = { class: "program-place" }
const _hoisted_22 = {
  class: "program-box",
  id: "creators_talk_1"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_24 = { class: "program-inner" }
const _hoisted_25 = { class: "program-time day-2" }
const _hoisted_26 = { class: "program-place" }
const _hoisted_27 = {
  class: "program-box",
  id: "beginner_tour_2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_29 = { class: "program-inner" }
const _hoisted_30 = { class: "program-time day-3" }
const _hoisted_31 = { class: "program-place" }
const _hoisted_32 = {
  class: "program-box",
  id: "kemo_club_1"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_34 = { class: "program-inner" }
const _hoisted_35 = { class: "program-time day-3" }
const _hoisted_36 = { class: "program-place" }
const _hoisted_37 = {
  href: "https://kemo.club/",
  target: "_blank"
}
const _hoisted_38 = {
  class: "program-box",
  id: "creators_talk_2"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_40 = { class: "program-inner" }
const _hoisted_41 = { class: "program-time day-3" }
const _hoisted_42 = { class: "program-place" }
const _hoisted_43 = {
  class: "program-box",
  id: "modify_avatar"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_45 = { class: "program-inner" }
const _hoisted_46 = { class: "program-time day-4" }
const _hoisted_47 = { class: "program-place" }
const _hoisted_48 = {
  class: "program-box",
  id: "kemo_club_2"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_50 = { class: "program-inner" }
const _hoisted_51 = { class: "program-time day-4" }
const _hoisted_52 = { class: "program-place" }
const _hoisted_53 = {
  href: "https://kemo.club/",
  target: "_blank"
}
const _hoisted_54 = {
  class: "program-box",
  id: "creators_talk_3"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_56 = { class: "program-inner" }
const _hoisted_57 = { class: "program-time day-4" }
const _hoisted_58 = { class: "program-place" }
const _hoisted_59 = {
  class: "program-box",
  id: "group_photo"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_61 = { class: "program-inner" }
const _hoisted_62 = { class: "program-time day-4" }
const _hoisted_63 = { class: "program-place" }
const _hoisted_64 = {
  class: "program-box",
  id: "ending"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_66 = { class: "program-inner" }
const _hoisted_67 = { class: "program-time day-4" }
const _hoisted_68 = { class: "program-place" }
const _hoisted_69 = {
  class: "program-box",
  id: "dead_dog_party"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "program-image",
  src: _imports_12,
  alt: ""
}, null, -1))
const _hoisted_71 = { class: "program-inner" }
const _hoisted_72 = { class: "program-time day-4" }
const _hoisted_73 = { class: "program-place" }
const _hoisted_74 = { class: "event-link" }
const _hoisted_75 = { class: "banner-link" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: "アバター＆ポスター募集中",
  width: "300",
  height: "80"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheDetailPageHeader = _resolveComponent("TheDetailPageHeader")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_SignalText = _resolveComponent("SignalText")!
  const _component_LinkButton = _resolveComponent("LinkButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheDetailPageBody = _resolveComponent("TheDetailPageBody")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheDetailPageHeader, { class: "page-program" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('page_title')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_TheDetailPageBody, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('p_1')), 1),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_1', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'time')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'p_1')), 1),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_1', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_1', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_2', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'time')), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'p_1')), 1),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_2', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_2', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_3', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'time')), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_3', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_3', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_3', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_3', 'caution_2')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_4', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'time')), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_4', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_4', 'caution_2')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_4', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_4', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_4', 'caution_3')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_4', 'caution_4')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_5', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'time')), 1),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'p_1')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'li_1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'li_2')), 1)
                ]),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_5', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_5', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_5', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_5', 'caution_2')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_6', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'time')), 1),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_6', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_6', 'caution_2')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_6', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_6', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_6', 'caution_3')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_6', 'caution_4')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_7', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'time')), 1),
                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'place')), 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_7', 'p_1_1')) + " ", 1),
                  _createElementVNode("a", _hoisted_37, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'link_1')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('program_7', 'p_1')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'p_2')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'p_3')), 1),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_7', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_7', 'p_4')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_8', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$props.i18n.$text('program_8', 'time')), 1),
                _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$props.i18n.$text('program_8', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_8', 'p_1')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('program_8', 'li_1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('program_8', 'li_2')), 1)
                ]),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_8', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_8', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_8', 'caution_2')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_9', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'time')), 1),
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_9', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_9', 'caution_2')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_9', 'caution_3')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_9', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_9', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_9', 'caution_4')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_10', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'time')), 1),
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'place')), 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_10', 'p_1_1')) + " ", 1),
                  _createElementVNode("a", _hoisted_53, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'link_1')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('program_10', 'p_1')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'p_2')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'p_3')), 1),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_10', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_10', 'p_4')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_11', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'time')), 1),
                _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'p_1')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'li_1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$props.i18n.$text('program_11', 'li_2')), 1)
                ]),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_11', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_11', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_11', 'caution_2')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_12', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'time')), 1),
                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'p_1')), 1),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_12', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_12', 'p_2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_13', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'time')), 1),
                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'p_1')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_13', 'caution_1')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_13', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_13', 'p_2')), 1),
                _createVNode(_component_SignalText, { signal: "note" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_13', 'caution_2')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, [
                _createVNode(_component_Heading, { tag: "h2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_14', 'title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'time')), 1),
                _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'place')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'p_1')), 1),
                _createVNode(_component_Heading, { tag: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('program_14', 'participation')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('program_14', 'p_2')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createVNode(_component_LinkButton, { href: "/access/instances" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('instance_link')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createVNode(_component_router_link, { to: "/program/apply_avatar_poster" }, {
              default: _withCtx(() => [
                _hoisted_76
              ]),
              _: 1
            }),
            _createVNode(_component_SignalText, { signal: "caution" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('caution_2')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}